import styled from 'styled-components'
import { Title } from '@usap/widgets'
import {
  Box,
  IcoMoon,
  Text,
  Button,
} from '@usap/uicomponents'

const BoxStyled = styled(Box)`
   display: inline-flex;
   display: inline-flex;
   flex-direction: row;
   border-top: 1px solid #E0E0E0;
   padding-top: 10px;
   margin-top: 5px;
 `

const LayerBoxStyled = styled(Box)`
  overflow-y:auto;
  overflow-x:none;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: auto;

  *::-webkit-scrollbar {
    display: block !important;
    width: 3em !important;
  }

  *::-webkit-scrollbar:vertical {
    width: 3em !important;
  }
   
  *::-webkit-scrollbar-track {
    display: block !important;
    background: #666666; 
  }
 
  *::-webkit-scrollbar-thumb {
    background: #E0E0E0; 
  }
  
  *::-webkit-scrollbar-thumb:hover {
    background: #333333; 
  }

  /* Gereric fallback */
  @media screen 
  and (min-height: 812px)
  and (orientation: landscape) { 
    height: 37vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 37);
  }
  
  /* iPhone 12, 12 Pro */
  @media only screen 
  and (device-width : 390px) 
  and (device-height : 844px) 
  and (orientation: landscape)
  and (-webkit-device-pixel-ratio : 3) { 
    height: 17em !important;
  }

  /* iPhone X and Xs Max */
  @media only screen 
  and (device-width : 375px) 
  and (device-height : 812px) 
  and (orientation: landscape)
  and (-webkit-device-pixel-ratio : 3) { 
    height: 17em !important;
  }

  @media only screen 
  and (device-width : 375px) 
  and (device-height : 812px) 
  and (orientation: portrait)
  and (-webkit-device-pixel-ratio : 3) { 
    height: 33em !important;
  }
  
  /* iPhone XR, 11 */
  @media only screen 
  and (min-device-width: 414px) 
  and (min-device-height: 896px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: portrait) { 
    height: 23em !important;
  }

  /* iPhone XS Max, 11 Pro Max */
  @media only screen 
  and (min-device-width: 414px) 
  and (min-device-height: 896px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) { 
    height: 17em !important;
  }

  /* iPhone 12 Pro Max */
  @media only screen 
  and (min-device-width: 428px) 
  and (min-device-height: 926px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) { 
    height: 17em !important;
  }

  /* iPhone 6/7/8
     iPhone 6/7/8 Plus
     Galaxy S5 */
  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 736px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {
    height: 16em;
  }

  @media only screen 
  and (min-device-width: 414px) 
  and (max-device-width: 736px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {
    height: 15em;
  }

  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 736px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: portrait) {
    height: 23em;
  }

  @media only screen 
  and (min-device-width: 414px) 
  and (max-device-width: 736px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: portrait) {
    height: 23em;
  }

  /* iPhone 4 and 4S */
  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 480px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {
    height: 13em;
  }

  /* iPhone 5/SE */
  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 568px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {
    height: 13em;
  }

  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 568px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: portrait) {
    height: 25em;
  }

  /* iPhone 8 */
  @media screen 
  and (device-width: 375px) 
  and (device-height: 667px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: landscape) {
    height: 17em;
  }

  @media screen 
  and (device-width: 375px) 
  and (device-height: 667px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: portrait) {
    height: 30em;
  }

  /* Galaxy S3 */ 
  @media screen 
  and (device-width: 320px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: landscape) {
    height: 13em;
  }

  /* Galaxy S4 and Note 3 */ 
  @media screen 
  and (device-width: 320px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) {
    height: 1em;
  }

  @media screen 
  and (device-width: 320px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: portrait) {
    height: 27em;
  }

  /* Galaxy S5 */
  @media screen 
  and (device-width: 360px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) {
    height: 17em;
  }

  /* Galaxy S6 */
  @media screen 
  and (device-width: 360px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 4) 
  and (orientation: landscape) {
    height: 17em;
  }

  /* Galaxy S6 */
  @media screen 
  and (device-width: 360px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 4) 
  and (orientation: landscape) {
    height: 17em;
  }

  /* Galaxy S8 */
  @media screen 
  and (device-width: 360px) 
  and (device-height: 740px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) {
    height: 17em;
  }

  /* Galaxy Fold */ 
  @media screen 
  and (device-width: 280px) 
  and (device-height: 653px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) {
    height: 12em !important;
  }

  @media screen 
  and (device-width: 280px) 
  and (device-height: 653px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: portrait) {
    height: 27em;
  }

  /* Moto G4 */ 
  @media screen 
  and (device-width: 320px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: portrait) {
    height: 85vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 85);
  }

  /* Pixel 2 XL */ 
  @media screen 
  and (device-width: 411px) 
  and (device-height: 823px) 
  and (-webkit-device-pixel-ratio: 3.5) 
  and (orientation: landscape) {
    height: 17em;
  }

  @media screen 
  and (device-width: 411px) 
  and (device-height: 823px) 
  and (-webkit-device-pixel-ratio: 3.5) 
  and (orientation: portrait) {
    height: 34em;
  }
`

const WrapperCloseButton = styled(Button)`
  margin-top: -18px !important;
  position: absolute !important;
  top: -22px !important;
  right: 3px;
  color: white !important;
  fill: white !important;
  font-size: 32px !important;
  svg {
    fill: white !important;
    stroke: white !important;
    width: 36px !important;
    height: 36px !important;
  }
}
`

const TitleStyled = styled(Title)`
  margin-bottom: 15px;
  line-height: 28px;  
`

const TextInfoStyled = styled(Text)`
  margin-top: 5px;
  line-height: 20px;
`
const TextSubtitleStyled = styled(Text)`
  line-height: 28px;
`

const IcoMoonStyled = styled(IcoMoon)`
  margin-top: 10px;
`

const TextStyled = styled(Text)`
  margin-bottom: 10px;
  line-height: 28px;
`

const TitleHowTostyled = styled(Title)`
  margin-top: 25px;
  margin-bottom: 15px;
  line-height: 28px;
`

export {
  BoxStyled,
  WrapperCloseButton,
  TitleStyled,
  TextInfoStyled,
  TextSubtitleStyled,
  IcoMoonStyled,
  TextStyled,
  TitleHowTostyled,
  LayerBoxStyled,
}
